import { render, staticRenderFns } from "./statuses-panel.vue?vue&type=template&id=b539670c&"
import script from "./statuses-panel.vue?vue&type=script&lang=js&"
export * from "./statuses-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports